import { GOOGLE_TAG_MANAGER_KEY } from "src/app/config";
export const gtmParams = {
    id: GOOGLE_TAG_MANAGER_KEY,
};
